import React from 'react';
import Box from '@material-ui/core/Box';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Icon from 'common/components/Icon';
import Radio from 'common/components/Radio';
import { makeOrderTypeStyles } from 'styles/pages/checkout';
import { Paper } from '@material-ui/core';
import { DEFAULT_PAPER_ELEVATION } from 'common/constants';
import { FormFieldNames, COUNSEL_PARENTS, SCHOOL } from '../../../common/constants';

type Props = { error: boolean; type: FormFieldNames.COUNSEL_PARENTS | FormFieldNames.SCHOOL };

const dataType = {
    [COUNSEL_PARENTS]: {
        icon: <Icon.OrderParents />,
        label: 'Zamówienie na radę rodziców',
        value: COUNSEL_PARENTS,
    },
    [SCHOOL]: {
        icon: <Icon.OrderSchool />,
        label: 'Zamówienie na szkołę',
        value: SCHOOL,
    },
};

const OrderType: React.FC<Props> = ({ error, type }) => {
    const { icon, label, value } = dataType[type];
    const { orderType } = makeOrderTypeStyles();

    const className = `${orderType} ${error ? 'error' : ''}`;

    return (
        <Paper elevation={DEFAULT_PAPER_ELEVATION} square>
            <Box
                alignItems="center"
                className={className}
                display="flex"
                flexDirection="column"
                px={2}
                py={4}
            >
                <Box alignItems="center" display="flex" justifyContent="center">
                    {icon}
                </Box>
                <FormControlLabel control={<Radio />} label={label} value={value} />
            </Box>
        </Paper>
    );
};

export default OrderType;
